import { combineReducers } from "redux";
const demo = (state = false , action) => {
    let returnselect
    switch (action.type) {
        case "demo" :
            returnselect = true;
            break;
        default:
            returnselect = state;
    }
    return returnselect
}
export default combineReducers({
    demo
});
